import { render, staticRenderFns } from "./TakeSurvey.vue?vue&type=template&id=5481263f&scoped=true&"
import script from "./TakeSurvey.vue?vue&type=script&lang=js&"
export * from "./TakeSurvey.vue?vue&type=script&lang=js&"
import style0 from "./TakeSurvey.vue?vue&type=style&index=0&id=5481263f&lang=scss&scoped=true&"
import style1 from "./TakeSurvey.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5481263f",
  null
  
)

export default component.exports